import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Analytics } from 'packages';
import uiActions from 'state/actions/ui';
import { SimpleModal, DialogModal } from 'components';
import Close from '@tradera/tradera-ui/icons/close.svg?jsx';
import './video-modal.scss';

const VideoModal = ({ dispatch, open, videoId, title, pageType }) => {
    const closeModalCallback = () => {
        dispatch(uiActions.closeVideoModal());
        Analytics.trackEvent({
            category: { pageType },
            action: 'VideoModal:Close',
            label: `${title} - Video id: ${videoId}`
        });
    };

    const videoUrl = `//www.youtube.com/embed/${videoId}?modestbranding=0&showinfo=0&autoplay=1&rel=0`;

    return (
        <div>
            {open === 'open' && (
                <DialogModal
                    onDismiss={() => closeModalCallback()}
                    className="video-modal-content">
                    <div
                        className="video-modal pt-md-4 pb-md-5 px-md-5 pt-2 pb-3 px-3"
                        onKeyDown={e => {
                            if (e.keyCode === 27) {
                                closeModalCallback();
                            }
                        }}>
                        <div className="row justify-content-between pb-2">
                            <div className="h3 d-md-block d-none text-truncate">
                                {title}
                            </div>
                            <span
                                className="close-button text-dark"
                                onClick={e => {
                                    closeModalCallback();
                                    e.stopPropagation();
                                }}>
                                <Close className="icon icon-dark" />
                            </span>
                        </div>
                        <div className="row">
                            <iframe
                                title="Kom igång med att handla på Tradera - Video"
                                className="video-iframe mx-2"
                                type="text/html"
                                src={videoUrl}
                                frameBorder="0"
                                allowFullScreen
                            />
                        </div>
                    </div>
                </DialogModal>
            )}
        </div>
    );
};

VideoModal.propTypes = {
    open: PropTypes.string,
    videoId: PropTypes.string,
    title: PropTypes.string,
    pageType: PropTypes.string
};

const mapStateToProps = (state, ownProps) => ({
    open: state.ui.videoModal.open,
    videoId: state.ui.videoModal.videoId,
    title: state.ui.videoModal.title,
    pageType: state.ui.videoModal.pageType,
    ...ownProps
});

export default connect(mapStateToProps)(VideoModal);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/modals/video-modal/video-modal.jsx